import React, { Component, Fragment } from "react";
import QuadrantEditorModal from "views/Pma/PmaEditor/TableQuadrants/TableQuadrantsPageOne/QuadrantEditorModal";
import { pmaActions } from "_store/_actions";
import { connect } from "react-redux";
import AddAreasModal from "views/Pma/PmaEditor/TableQuadrants/TableQuadrantsPageOne/AddAreasModal";

class QuadrantContainer extends Component {
  state = {
    editQuadrantFormData: null,
    oldQuadrantData: [],
    selectedQuadrantNumber: null,
    titleEdit: false,
    maxMainTitleLength: 50,
    addAreasModalOpen: false,
    filteredAreas: {},
    maxMainSubtitleLength: 57,
    savingMessageShowing: false,
  };

  handleFormClose = () => {
    this.props.updateQuadrantModalOpen(false);
    this.setState({
      titleEdit: false,
      addAreasModalOpen: false,
      savingMessageShowing: false,
    });
  };
  onEditFormSubmit = () => {
    const { editQuadrantFormData, oldQuadrantData } = this.state;
    let foundIndex = oldQuadrantData.findIndex(
      (x) => x.quadAreaID === editQuadrantFormData.quadAreaID
    );
    oldQuadrantData[foundIndex] = editQuadrantFormData;
    this.props.setQuadrantDetails(oldQuadrantData);
    this.setState({
      savingMessageShowing: true,
    });
    setInterval(() => {
      this.setState({ savingMessageShowing: false });
    }, 5000);
  };
  openSelectedQuadrant = (quadrantNumber, titleEdit) => {
    this.props.updateQuadrantModalOpen(true);
    this.setState({
      selectedQuadrantNumber: quadrantNumber,
      titleEdit: titleEdit,
      savingMessageShowing: false,
    });
  };
  componentDidMount = () => {
    if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }
    const { quadrantDetails, currentArea } = this.props;
    this.props.updateQuadrantModalOpen(false);
    const details = Array.isArray(quadrantDetails) ? quadrantDetails : [];
    const areaId = currentArea && currentArea.mlsAreaID;
    let newObj = details
      .filter((quadrantObj) => quadrantObj.quadAreaID === areaId)
      .map((i) => ({ ...i }))[0];

    if (!newObj && areaId && String(areaId).includes("DEMO")) {
      newObj = details[0];
    }
    this.setState({
      oldQuadrantData: details.map((i) => ({ ...i })),
      editQuadrantFormData: details
        .filter((quadrantObj) => quadrantObj.quadAreaID === areaId)
        .map((i) => ({ ...i }))[0],
    });
  };
  handleRestoreDefault = () => {
    const {
      selectedQuadrantNumber,
      editQuadrantFormData,
      oldQuadrantData,
      titleEdit,
    } = this.state;
    if (titleEdit) {
      this.setState({
        // mainTitle: oldTitle,
        // subtitle: oldSubtitle,
      });
    } else if (selectedQuadrantNumber >= 0) {
      let newObj = [...editQuadrantFormData].map((i) => ({ ...i }));
      let oldSelection = [...oldQuadrantData].map((i) => ({
        ...i,
      }))[selectedQuadrantNumber];
      newObj[selectedQuadrantNumber].text = oldSelection.text;
      this.setState({
        editQuadrantFormData: newObj,
      });
    }
  };
  handleInputChange = (e) => {
    const { editQuadrantFormData } = this.state;
    const target = e.target;
    const value = target.value;
    const name = target.name;
    let clonedEditQuadrantFormData = Object.assign(editQuadrantFormData, {
      [name]: value,
    });
    this.setState({
      editQuadrantFormData: clonedEditQuadrantFormData,
    });
  };
  applyToAllAreas = () => {
    console.log("applyToAllAreas");
  };

  render() {
    const {
      mlsAreas,
      quadrantModalOpen,
      currentArea,
      printVersion,
      fromEditor,
      showAllEditButtons,
    } = this.props;

    const { openSelectedQuadrant, handleInputChange, handleRestoreDefault } =
      this;
    const {
      editQuadrantFormData,
      oldQuadrantData,
      selectedQuadrantNumber,
      titleEdit,
      addAreasModalOpen,
      maxMainTitleLength,
      maxMainSubtitleLength,
      savingMessageShowing,
    } = this.state;
    let subtitleStyles;
    let quadrantStyles;
    let showButtons = fromEditor && showAllEditButtons;
    // let showButtons = true;
    let quadrantTitleStyles;
    if (editQuadrantFormData && Object.keys(editQuadrantFormData).length >= 1) {
      const {
        quadAreaTitle,
        quadAreaSubTitle,
        quad1Title,
        quad1Text,
        quad2Title,
        quad2Text,
        quad3Title,
        quad3Text,
      } = editQuadrantFormData;
      return (
        <Fragment>
          {addAreasModalOpen && (
            <AddAreasModal
              addAreasModalOpen={addAreasModalOpen}
              mlsAreas={mlsAreas}
              currentArea={currentArea}
              onCloseFn={this.handleFormClose}
              onEditFormSubmit={this.onEditFormSubmit}
              editQuadrantFormData={editQuadrantFormData}
            />
          )}
          {editQuadrantFormData &&
            Object.keys(editQuadrantFormData).length >= 1 &&
            quadrantModalOpen && (
              <QuadrantEditorModal
                oldQuadrantData={oldQuadrantData}
                onCloseFn={this.handleFormClose}
                handleInputChange={handleInputChange}
                editQuadrantFormData={editQuadrantFormData}
                onEditFormSubmit={this.onEditFormSubmit}
                selectedQuadrantNumber={selectedQuadrantNumber}
                handleRestoreDefault={handleRestoreDefault}
                titleEdit={titleEdit}
                mlsAreas={mlsAreas}
                maxMainTitleLength={maxMainTitleLength}
                maxMainSubtitleLength={maxMainSubtitleLength}
                savingMessageShowing={savingMessageShowing}
              />
            )}
          <div
            className={`${
              printVersion
                ? "print-april-2023-quadrant-container"
                : "editor-april-2023-quadrant-container"
            } ${quadrantStyles && quadrantStyles} `}
          >
            <div className="quadrant">
              <div className="quadrant-title-container">
                <div
                  className={`quadrant-title-text ${quadrantTitleStyles}`}
                  dangerouslySetInnerHTML={{ __html: quadAreaTitle }}
                ></div>
                <div
                  className={`quadrant-subtitle-text ${subtitleStyles}`}
                  dangerouslySetInnerHTML={{
                    __html: quadAreaSubTitle !== "-" ? quadAreaSubTitle : "",
                  }}
                ></div>
              </div>
              <div className="quadrant-body">
                {fromEditor && showButtons && !quadrantModalOpen && (
                  <>
                    <div
                      className="quadrant-btn quadrant-title-btn"
                      onClick={() => openSelectedQuadrant(null, true)}
                    >
                      <div>Edit this section</div>
                    </div>
                    <div
                      className="quadrant-btn quadrant-btn-1"
                      onClick={() => openSelectedQuadrant(1)}
                    >
                      <div>Edit this section</div>
                    </div>
                    <div
                      className="quadrant-btn quadrant-btn-2"
                      onClick={() => openSelectedQuadrant(2)}
                    >
                      <div>Edit this section</div>
                    </div>
                    <div
                      className="quadrant-btn quadrant-btn-3"
                      onClick={() => openSelectedQuadrant(3)}
                    >
                      <div>Edit this section</div>
                    </div>
                  </>
                )}
                <div className="section-container">
                  <div className="section-row">
                    <div
                      className={`${
                        1 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-1`}
                      // onClick={() => openSelectedQuadrant(1)}
                      key={1}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: quad1Title }}></p>
                        <div className="quadrant-section-title-divider" />
                      </div>
                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: quad1Text }}
                      ></div>
                    </div>
                    <div
                      className={`${
                        2 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-2`}
                      // onClick={() => openSelectedQuadrant(2)}
                      key={2}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: quad2Title }}></p>
                        <div className="quadrant-section-title-divider" />
                      </div>
                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: quad2Text }}
                      ></div>
                    </div>
                    <div
                      className={`${
                        3 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-3`}
                      // onClick={() => openSelectedQuadrant(3)}
                      key={3}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: quad3Title }}></p>
                        <div className="quadrant-section-title-divider" />
                      </div>
                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: quad3Text }}
                      ></div>
                    </div>
                    {/*<div
                      className={`${
                        4 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-4`}
                      // onClick={() => openSelectedQuadrant(4)}
                      key={4}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: quad4Title }}></p>
                        <div className="quadrant-section-title-divider" />
                      </div>
                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: quad4Text }}
                      ></div>
                    </div>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return <div>Loading Quadrants...</div>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    quadrantModalOpen: state.pma.quadrantModalOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateQuadrantModalOpen: (isModalOpen) => {
      dispatch(pmaActions.updateQuadrantModalOpen(isModalOpen));
    },
    setQuadrantDetails: (quadrantDetails) => {
      dispatch(pmaActions.setQuadrantDetails(quadrantDetails));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(QuadrantContainer);
